// issue-analysis's root component — an adapter over DashboardShell (IA_ABSORPTION_PLAN Phase 3
// step 8; in project-overview's host layout, App/{component.vue,model.js,setup.js,style.css},
// since 2026-10-12 — a `<script setup>` single file until then). The chrome is
// @rdrive/plugin-dashboard-shell's DashboardShell: app bar + nav, kebab (theme / fullscreen /
// DuckDB Query), the missing-params and DuckDB-query dialogs, the page container with the welcome
// dialog. DashboardShell is the root, as in project-overview: no outer v-layout since 2026-10-13
// (the app always wrapped v-app in one — that made the shell's v-app a NESTED Vuetify layout,
// whose app bar is `position: absolute` and scrolled away with the page; at the root it is
// `fixed`, so the nav bar stays put). The FAB in the shell's `fab` slot (inside .content-container — `position: fixed`, so it
// does not move) is @rdrive/plugin-status-filter's StatusFilterFab since IA_ABSORPTION_PLAN
// Phase 4 step 13.2, fed by composables/useIssueStatusFilters (its SQL, both contexts) with
// "overdue only" as its opt-in extra toggle. Keep comments out of the template: in dev a
// root-level comment makes the root a fragment. <router-view> needs no `components` entry:
// vue-router registers it globally (createDashboard's app.use(router); routes in
// dashboard.config.js).
import { DashboardShell } from '@rdrive/plugin-dashboard-shell';
import { StatusFilterFab } from '@rdrive/plugin-status-filter';
import setup from './setup.js';

export default {
  name: 'app',
  components: { DashboardShell, StatusFilterFab },
  setup,
};
